import './Hero.scss'
import {Button} from '../../atoms'
const Hero = () => {
  return (
    <section className="_hero">
      <div className="container">
        <div className="wrapper">
          <div className="row justify-content-center mb-4">
            <div className="col-lg-8">
              <h1 className="title my-3">
                Safest launchpad for real case utility Token.
              </h1>
              <h2 className="sub-title my-3">Backed by IDM </h2>
              {/* <p className="desc my-3">
                Backed by IDM 
              </p> */}
              <div className="d-flex justify-content-around mt-5">
                <Button type="link" to="/create?step=1" w={250} h={50} className="btn-yellow mx-3" title="Apply Now" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
